import Request from "@/libraries/request.js";
import Const from "@/const/const.js";

export default {
  BaseURL: "/supplier/",
  async get(url = null) {
    const suppliers = await Request.getAsync(url);
    let data = {};
    if (suppliers.data.status) {
      data = suppliers.data.data;
    }else{
      throw new Error(suppliers.data.msg);
    }
    return data;
  },
  async get_supplier(supId = null) {
    if (supId == null) {
      throw new Error("Supplier ID not found.");
    }
    const url = this.BaseURL + supId;
    const data = await this.get(url);
    return data[0];
  },
  async get_all_supplier() {
    return await this.get(this.BaseURL);
  }
};



// WEBPACK FOOTER //
// ./src/model/supplier_model.js